export const API_URLS = {
    AUTHENTICATE: '/web/player/v1/auth',

    AUTHENTICATE_REVERSE: '/web/player/v1/auth-reverse',

    REFRESH_TOKEN: '/web/player/v1/refresh',

    PLAYER_SETTINGS: '/web/player/v1/settings',

    INITIAL: '/web/partner/v1/initial',

    BET_HISTORY: '/web/player/v1/bet-history',

    RECENT_BETS: '/web/player/v1/recent-bets',

    PARTICIPANTS: '/web/participant/v1/list',

    PARTICIPANTS_DETAILS: '/web/participant/v1/details',

    TOURNAMENT_DETAILS: '/web/game/tournament/v1/details',

    UPCOMING_TOURNAMENTS_LIST: '/web/game/tournament/v1/list/upcoming',

    RNG_MATCH_RESULTS: '/web/game/v1/results',

    PAST_TOURNAMENTS: '/web/game/tournament/v1/list/past',

    STANDINGS: '/web/game/tournament/v1/standings',

    ARCHIVE: '/web/tournament-match/v1/archive',

    TRANSLATIONS: '/web/static/v1/translation',

    BALANCE: '/web/player/v1/balance/get',

    HOW_TO_PLAY: '/web/game/v1/how-to-play',

    HOW_TO_PLAY_VIDEO: '/web/game/v1/how-to-play-video',

    STATIC: '/web/static/v1',

    STREAM: '/web/stream/v1/get',

    SINGLE_LIMITS: '/web/betting/v1/limits/single',

    COMBINATION_LIMITS: '/web/betting/v1/limits/combination',

    PLACE_BET_SINGLE: '/web/betting/v1/pay-in/single',

    PLACE_BET_COMBO: '/web/betting/v1/pay-in/combination',

    BET_STATUSES: '/web/player/v1/bet-statuses',

    // local APIs
    PARTNER_FEATURES: '/partner',
};
